import { UIComponentProps, UIComponentState, UIComponentHandler, UIComponentImpl, UIDataModel } from '../../../../toolkit/uicomponent';
import { UIComponentView } from '../../../../toolkit/uicomponentview';
import { ManageBlacklistView } from './manageblacklistview';
import { UIComponentCSSStyle } from '../../../../toolkit/uicomponentcss';
import { ManageBlacklistCSSStyleImpl } from './manageblacklistcss';
import { MemberDetailsDto } from 'src/com/sixdee/crbtportal/core/dto/listtones/memberdetailsdto';
import { ManageBlacklistAPIModelImpl, ManageBlacklistAPIModel } from './manageblacklistapimodel';
import { APIModelHandler, APIModel } from '../../../../toolkit/uicomponentapimodel';
import { APIFeatures } from 'src/com/sixdee/crbtportal/core/util/apifeatures';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { BlacklistDto, BlacklistDtoImpl } from 'src/com/sixdee/crbtportal/core/dto/blacklist/blacklistdto';
import { ManageGroupType } from '../../groups/managegroup/managegrouptype';


export interface ManageBlacklistProps extends UIComponentProps
{
    blacklistDto: BlacklistDto;
    manageBlacklistType: ManageGroupType;
    listOfBlacklistMembers:MemberDetailsDto[];
    
    onCancelClicked(): void;
}

export interface ManageBlacklistState extends UIComponentState
{
    manageBlacklistType: ManageGroupType;
    listOfBlacklistMembers: MemberDetailsDto[];
}

export interface ManageBlacklistHandler extends UIComponentHandler
{
    onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto): void;
    onAddMemberClicked(memberDetailsDto: MemberDetailsDto): void;

    onCreateBlacklistClicked(): void;
}

export class ManageBlacklistComponent extends UIComponentImpl<ManageBlacklistProps, ManageBlacklistState, UIDataModel> implements ManageBlacklistHandler
{
    constructor(props: ManageBlacklistProps)
    {
        super(props);

        this.state = {listOfBlacklistMembers: props.blacklistDto.getMembersList(), manageBlacklistType: props.manageBlacklistType};
    }

    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new ManageBlacklistView(applicationContext, uiComponentHandler);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new ManageBlacklistCSSStyleImpl(applicationContext);
    }

    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new ManageBlacklistAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps(nextProps: ManageBlacklistProps)
    {
        this.setState({
            listOfBlacklistMembers: nextProps.blacklistDto.getMembersList(), manageBlacklistType: nextProps.manageBlacklistType});
    }
    

    validate(): boolean
    {
       return (this.getView() as ManageBlacklistView).validate();
    }

    showEditMode(): void {
      this.setState({manageBlacklistType: ManageGroupType.EDIT});
    }

    onDeleteMemberClicked(memberDetailsDto: MemberDetailsDto): void 
    {
        this.setState({listOfBlacklistMembers: this.state.listOfBlacklistMembers.filter((t: MemberDetailsDto)=>
            {
                return t.getMsisdn() !== memberDetailsDto.getMsisdn();
            })});
    }

    onAddMemberClicked(memberDetailsDto: MemberDetailsDto): void 
    {
        this.state.listOfBlacklistMembers.push(memberDetailsDto);
     
        this.setState({listOfBlacklistMembers: this.state.listOfBlacklistMembers});
    }

    onCreateBlacklistClicked()
    {
        let groupDto = this.props.blacklistDto as BlacklistDtoImpl;

        let listofmembers =  this.state.listOfBlacklistMembers.filter((memberDetailsDto: MemberDetailsDto, index: number) =>
        {
            return index !== 0 && memberDetailsDto;
        });
        groupDto.setMembersList(listofmembers);

        console.log("onCreate: " + JSON.stringify(groupDto));

       (this.getAPIModel() as ManageBlacklistAPIModel).onCreateBlacklist(groupDto);
    }
  
    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
       if(feature === APIFeatures.ADD_TO_BLACKLIST)
       {
          this.props.onCancelClicked();
       }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/blacklist/manageblacklist/manageblacklistcomponent.tsx